import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { mealTypesToDisplay } from 'types/meals';
import { StyledSelect } from './MealsSelect.style';

const MealsSelect = ({ meals, defaultValue, className, disabled, placeholder = '', intl, name, onChange = () => null }) => (
  <StyledSelect className={`${className} meal-select`} id={name} disabled={disabled} onChange={onChange}>
    {disabled && placeholder && (
      <option key={placeholder} value="" selected>
        {intl.formatMessage({ id: placeholder })}
      </option>
    )}
    {meals.map(({ id: mealId }) => (
      <option key={mealId} value={mealId} selected={mealId === defaultValue}>
        {intl.formatMessage({ id: `mealTypes.${mealTypesToDisplay[mealId]}` })}
      </option>
    ))}
  </StyledSelect>
);

MealsSelect.propTypes = {
  defaultValue: PropTypes.string,
  meals: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),
  className: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  intl: intlShape,
  onChange: PropTypes.func
};

export default injectIntl(MealsSelect);
